<template><div><h1 id="kapitel-7-administration" tabindex="-1"><a class="header-anchor" href="#kapitel-7-administration"><span>Kapitel 7. Administration</span></a></h1>
<p>Dieser Teil beinhaltet die Administration.</p>
</div></template>


